<template>
  <v-treeview
    activatable
    open-on-click
    return-object
    transition
    v-bind:items="items"
    v-bind:load-children="fetchChildren"
    v-on:update:active="onChangeActive"
  />
</template>

<script>
export default {
  created() {
    this.$emit('created');
  },
  methods: {
    onChangeActive(item) {
      this.$emit('change', item[0]);
    },
  },
  props: {
    /**
     * @description Получить дочерние элементы.
     * @type {function}
     */
    fetchChildren: { required: true, type: Function },
    /**
     * @description Элементы.
     * @type {{id:string, name:string, children:any[]}[]}
     */
    items: { required: true, type: Array },
  },
};
</script>

<style scoped lang="scss">
.popup {
  &__exit {
    margin: 5px 5px 0 auto;
  }
}
::v-deep {
  .mdi-menu-down::before {
    content: "";
    background-image: url("@/assets/img/checked/checked-grey.svg");
    background-size: contain;
    background-position: center;
    width: 12px;
    height: 10px;
    cursor: pointer;
  }
  .v-treeview-node__label {
    white-space: normal;
  }
}

</style>
